import React, { useEffect, useState } from 'react'
import HeaderAlert from './HeaderAlert'
import moment from 'moment'
import { Icon, Image, Popup, Message } from 'semantic-ui-react'
//import {QryFuncModal} from "../../qryFunc";
import { QryFuncModal } from 'kx-common-components'
import Images from '../../../config/images'
import { isEmpty } from 'lodash'
import EntryStatusModal from './EntryStatusModal'
import _ from 'lodash'
import { getK84Date } from '../../../CBSA_App/api/getEntrySummaryData'

const nth = function (d) {
  if (d > 3 && d < 21) return 'th'
  switch (d % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

function formatDate(inputDate) {
  if(inputDate === ""){
    return;
  }
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const dateParts = inputDate.split('-');
  const year = dateParts[0];
  const monthIndex = parseInt(dateParts[1]) - 1;
  const day = dateParts[2];

  const month = months[monthIndex];

  // Function to add 'th', 'st', 'nd', or 'rd' to the day
  function getDayWithSuffix(day) {
    if (day >= 11 && day <= 13) {
      return day + 'th';
    }
    switch (day % 10) {
      case 1:
        return day + 'st';
      case 2:
        return day + 'nd';
      case 3:
        return day + 'rd';
      default:
        return day + 'th';
    }
  }

  const formattedDate = `${month} ${getDayWithSuffix(day)}, ${year}`;
  return formattedDate;
}


export function statesToCWOrDISAlerts(allStates, jsonResponse=false) {
  allStates=allStates||[];
  function replaceTextCardStuff(text) {
    if (!text) return ''
    text = text.replaceAll('STATE_', '')
    text = text.replaceAll('_', ' ')
    text = text.trim()
    if (text.toUpperCase() == 'DOCUMENT FILED') {
      text = 'DIS SENT'
    }
    return text
  }

  let disstate = allStates.find((a) => a.key == 'SHIPMENT_DIS_PROCESS')


  let pgaUpdateState = allStates.find((a) => a.key == "SHIPMENT_US_PGA_PROCESS")?.value?.state;
  let pgaUpdateText = ''
  if (
    [
      'STATE_PGA_UPDATE_REQUIRED',
      'STATE_PGA_UPDATE_IN_PROCESS',
      'STATE_PGA_UPDATE_READY_TO_FILE',
      'STATE_PGA_UPDATE_FILED',
      'STATE_PGA_UPDATE_ACCEPTED',
      'STATE_PGA_UPDATE_REJECTED',
      'STATE_PGA_UPDATE_ACCEPTED_WITH_WARNINGS',
    ].includes(pgaUpdateState)
  ) {
    pgaUpdateText = pgaUpdateState
  }


  let cwUpdateState = allStates.find((a) => a.key == "SHIPMENT_US_CW_PROCESS")?.value?.state ||"";
  let cwUpdateText = cwUpdateState
    .replaceAll('_', ' ')
    .replaceAll('STATE ', '')
  if (jsonResponse) {
    function commentObjectCreator(name, description) {
      description = replaceTextCardStuff((description || "").toUpperCase());
      return {
        "statusName": name,
        "statusOriginalValue": name,
        "statusValue": description,
        "statusSeverity": `STATUS_CODE_${(description.includes('REJECTED') || description.includes("FAILURE")) ? "FAILURE" : "SUCCESS"}`,
        "statusPriority": 0,
        "hidden": false,
        "fieldmessage": description,
        "field": name,
        "fieldmessagetype": (description.includes('REJECTED') || description.includes("FAILURE")) ? "FAILURE" : "SUCCESS"
      }
    }
    let resulttt = [];

    if (disstate &&
      disstate.value &&
      disstate.value.state != 'STATE_DOCUMENT_NONE') {
        resulttt.push(commentObjectCreator("DIS",disstate.value.state))
    }
    if (pgaUpdateText) {
      resulttt.push(commentObjectCreator("PGA",pgaUpdateText))
    }
    if(cwUpdateText && !cwUpdateText.includes('NONE')){
      resulttt.push(commentObjectCreator("CW",cwUpdateText))
    }
    return resulttt;
  }
  return <>

    {disstate &&
      disstate.value &&
      disstate.value.state != 'STATE_DOCUMENT_NONE' && (
        <span style={{ color: 'red' }}>
          <Icon name='asterisk' />
          {replaceTextCardStuff(disstate.value.state)}
          <br />
        </span>
      )}
    {pgaUpdateText && (
      <span
        className='pgaUpdateText'
        style={{ color: 'green', marginRight: '3px' }}
      >
        <Icon name='asterisk' />
        {pgaUpdateText}
        <br />
      </span>
    )}
    {cwUpdateText && !cwUpdateText.includes('NONE') && (
      <span
        className='pgaUpdateText'
        style={{
          color: cwUpdateText.includes('REJECTED') ? 'red' : 'green',
        }}
      >
        <Icon name='asterisk' />
        {cwUpdateText}
        <br />
      </span>
    )}
  </>
}

//bolIdData = {modeOfTransport: 'AIR', masterBolNumber: '1234' }
export const mbolButton = (bolIdData, shipmentId) =>{
  const canFileMBolQuery = (bolIdData) => {
    if (bolIdData.modeOfTransport !== 'AIR') {
      return true
    }
    let airCarrierCode = window.airCarrierCode
    let blockedCarrierCode = ['5X', 'D0', 'FX']
    let mbol = bolIdData.masterBolNumber
    if (blockedCarrierCode.includes(airCarrierCode)) {
      return false
    }
    if (
      mbol.startsWith('406') ||
      mbol.startsWith('023') ||
      mbol.startsWith('936')
    ) {
      return false
    }
    return true
  }
  
  return <>{canFileMBolQuery(bolIdData) === true ? (
    <QryFuncModal
      brokerId={window.brokerId}
      launchFrom={'ISF_HEADER'}
      hideLeftPanel={true}
      dataType={'BOL'}
      width={'75%'}
      shipId={shipmentId}
      isMBL={true}
      queryRanFor={
        bolIdData.modeOfTransport === 'AIR'
          ? 'MAWB'
          : bolIdData.modeOfTransport == 'TRUCK'
          ? 'PAPS'
          : 'MBL'
      }
      value={
        bolIdData.modeOfTransport !== 'AIR' &&
        bolIdData.masterBolNumber
          ? bolIdData.masterBolNumber.toUpperCase()
          : ''
      }
      bolNum={
        bolIdData.modeOfTransport !== 'AIR' &&
        bolIdData.masterBolNumber
          ? bolIdData.masterBolNumber.toUpperCase()
          : ''
      }
      mBol={
        bolIdData.masterBolNumber
          ? bolIdData.masterBolNumber.toUpperCase()
          : ''
      }
      recentQryCall={false}
      mot={bolIdData.modeOfTransport}
      buttontext={
        <Icon
          name='info circle'
          color='blue'
          style={{ cursor: 'pointer' }}
        />
      }
      adminAccountReadonly={
        window.typeOfUser === 'BROKER_KN_ADMIN'
      }
      bolIdData={{ ...bolIdData, nonModalWindow: true }}
      baseUrl={window._env_.REACT_APP_BROKER_API_URL}
    />
  ) : (
    <Icon
      name='info circle'
      color='blue'
      style={{ cursor: 'pointer' }}
      onClick={() => {
        alert(
          'MAWB queries are not allowed for FedEx, DHL, and UPS - i.e. carrier codes FX, 5X, and D0 or with MAWB’s beginning with 023, 406, and 936.  These MAWB queries will pull the entire manifest for the plane and slow down the system.  If you need more info please work with the Importer or Carrier. '
        );
      }}
    />
  )}</>
}

const ISFHeader = ({
  bolIdData,
  shipId,
  purchaseOrder,
  entryNumber,
  entryTypeInfo,
  modeOfTransport,
  toggleState,
  commentObjectForHeader,
  entryState,
  toggle,
  id,
  aceOpen,
  closseAce,
  clicked,
  shipmentCountry,
  badge,
  ducr,
  epu,
  mucr,
  mrn,
  declarationType,
  serviceType,
  isLvsShipment,
  parentShipmentId,
  isParentShipment,
  erState,
  crState,
  custRef,
  kxUser,
  engineBolRecords,
  searchByID,
  openHotShipmentNotes,
  pscChainRawResponse,
  formType
}) => {
  const isGB = shipmentCountry === 'GB';
  let pscProcess = (pscChainRawResponse?.child || []).find(oneChain=>oneChain?.humanReadableId == shipId)?.pscProcess;
  if(pscProcess){
    pscProcess=pscProcess.replaceAll("STATE_","");
    pscProcess=pscProcess.replaceAll("_"," ");
  }
  const isCA = shipmentCountry === 'CA';
  const isUS = shipmentCountry === 'US';
  const [k84Date, setK84Date] = useState("")
  const [b3AcceptedDate, setB3AcceptedDate] = useState("")
  const [paymentDueDate, setPaymentDueDate] = useState("")
  const dateOfFiling = function (state) {
    let date =
      moment
        .tz(state.transitionTime, 'America/Toronto')
        .format('MMM DD, YYYY') === 'Invalid date'
        ? null
        : moment
            .tz(state.transitionTime, 'America/Toronto')
            .format('MMM DD, YYYY')

    let day = date.substring(4, 6)
    let month = date.substring(0, 3)
    let year = date.substring(8, 12)
    return month + ' ' + day + nth(day) + ',' + year
  }

  var hideBol = 'inline'
  var entryNum = 'ENTRY NUMBER :'
  if (isCA) {
    hideBol = 'none'
    entryNum = 'TRANSACTION NUMBER'
  }

  if (entryState) {
    let esStateArr = entryState.split('_')
    var esState = esStateArr[esStateArr.length - 1]
  }

  const [textCopied, setTextCopiedVal] = useState(false)
  const [showFullPo, setShowFullPo] = useState(false)
  const renderCopyFieldIcon = ({ textCopied, fieldInfo }) => {
    return (
      !isEmpty(fieldInfo) && (
        <Popup
          content={textCopied ? 'Copied!' : 'Click to copy'}
          position='top center'
          trigger={
            <Icon
              name={textCopied ? 'check circle' : 'copy'}
              className='copyToClipboard'
              style={{ color: textCopied ? '#008B8F' : '#867474' }}
              onClick={() => {
                navigator.clipboard.writeText(fieldInfo)
                setTextCopiedVal(true)
                setTimeout(() => {
                  setTextCopiedVal(false)
                }, 2000)
              }}
            />
          }
        />
      )
    )
  }

  const formTitle = () => {
    return `CUSTOMS CLEARANCE FORM (${window.shipmentCountry})`
  }

useEffect(()=>{
  if(window.shipmentCountry == 'CA'){
      getK84Date(shipId).then(res=>{
        if(res.data.eventMessage.fieldmessage){
          res.data.eventMessage.fieldmessage.map((message)=>{
            if(message.field === "ACCEPTED_DATE"){
              setB3AcceptedDate(message.fieldmessage)
            }
            else if(message.field === "DN_DATE"){
              setK84Date(message.fieldmessage)
            }
            else if(message.field === "PAYMENT_DUE_DATE"){
              setPaymentDueDate(message.fieldmessage)
            }
          })
        }
        else{
          setB3AcceptedDate("")
          setK84Date("")
          setPaymentDueDate("")
        }
      })
    }
},[shipId])

  const canEditEntryNumber = () => {
    const states = [
      'STATE_ENTRY_NONE',
      'STATE_ACCEPTED_ENTRY_ROUTE_1_C',
      'STATE_ACCEPTED_ENTRY_ROUTE_2_C',
      'STATE_ACCEPTED_ENTRY_ROUTE_3_C',
      'STATE_ACCEPTED_ENTRY_ROUTE_6_C',
    ]
    if (
      isGB &&
      states.includes(entryState) &&
      !entryNumber
    ) {
      return true
    } else if (
      isGB &&
      entryNumber &&
      entryState === 'STATE_ENTRY_NONE'
    ) {
      return true
    }
    return false
  }

  const canFileMBolQuery = () => {
    if (modeOfTransport !== 'AIR') {
      return true
    }
    let airCarrierCode = window.airCarrierCode
    let blockedCarrierCode = ['5X', 'D0', 'FX']
    let mbol = bolIdData.masterBolNumber
    if (blockedCarrierCode.includes(airCarrierCode)) {
      return false
    }
    if (
      mbol.startsWith('406') ||
      mbol.startsWith('023') ||
      mbol.startsWith('936')
    ) {
      return false
    }
    return true
  }

  const warningMessage = _.get(openHotShipmentNotes ,"[0].description")
  const canadaFormType = {
    "CARM": "CAD",
    "CBSA": "B3"
  }

  const engineEntryNumber = entryTypeInfo?.entryNumber ? `${entryTypeInfo?.filerCode || ""}${entryTypeInfo?.entryNumber || ""}${entryTypeInfo?.checkDigit || ""}` : "Not Assigned"  
  return (
    <>
      <div
        id={'divHeader'}
        className={
          entryState === 'STATE_ASSIGNED_TO_BROKER'
            ? 'header-alert new'
            : 'header-alert'
        }
      >
        <>
          <div className='overview-section-heading'>
            <div
              className={!isLvsShipment ? 'header-ship' : ''}
              style={{ border: modeOfTransport === 'AIR' ? 'none' : null }}
            >
              {!modeOfTransport ? (
                <Icon className='question icon newJobsHeaderIcon' />
              ) : isLvsShipment ? (
                <Image src={Images['lvsShipment']} />
              ) : (
                <Image src={Images[modeOfTransport]} />
              )}
            </div>
            {isLvsShipment ? (
              <div className={'header-label'}>LVS Shipment </div>
            ) : (
              <div className={'header-label'}>{formTitle()}</div>
            )}
          </div>
          <div
            style={{
              border: '1px solid rgb(38, 118, 120)',
              color: 'rgb(38, 118, 120)',
              fontSize: '10px',
              fontWeight: 'bold',
              padding: '1px',
              marginTop: '4px',
              marginLeft: '-2px',
              borderRadius: '2px',
              width: 'fit-content',
            }}
          >
            {declarationType === 'EX'
              ? 'EXPORT'
              : declarationType === 'IM'
              ? 'IMPORT'
              : serviceType
              ? serviceType
              : 'IMPORT'}
          </div>
        </>
        {shipId !== 'NoJobsAvailable' &&
          shipId !== '' &&
          shipId !== undefined && (
            <div className={`overview-info`}>
              <div className={`overview-info-left`} id='entryNumber'>
                <div className={`overview-info-item`}>
                <span className={`overview-info-label`}>{entryNum}:</span>
                {
                  window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken' ?
                    <span>{engineEntryNumber}</span>
                    :<>{entryNumber && <span>{entryNumber.toUpperCase() || "Not Assigned"}</span>}</>
                }
                  {canEditEntryNumber() && (
                    <span>
                      {' '}
                      <EntryStatusModal
                        shipId={shipId}
                        epuData={epu}
                        kxUser={kxUser}
                        searchByID={searchByID}
                      />
                    </span>
                  )}
                </div>
                {isGB && (
                  <div className={`overview-info-item`}>
                    <span className={`overview-info-label`}>DUCR:</span>
                    <span>{ducr}</span>
                  </div>
                )}
                <div className={`overview-info-item`}>  
                  <input
                    type='hidden'
                    id='shipmentIdInHeaderx'
                    value={shipId}
                  />
                  <span className={`overview-info-label`}>
                    {(shipId||"").startsWith("KN")?"TRANSACTION ID:":"SHIPMENT ID:"}</span> 
                    {pscProcess && <span className="pscSelectorDropdown small">{pscProcess}</span>}
                  <span>
                    {shipId}
                    {renderCopyFieldIcon({ textCopied, fieldInfo: shipId })}
                  </span>
                </div>
                {/* if custRef, show custRef, else PO, else null */}
                {custRef ? (
                  <div className={`overview-info-item`}>
                    <span className={`overview-info-label`}>Customer Ref:</span>
                    <span>{custRef}</span>
                  </div>
                ) : purchaseOrder ? (
                  <div className={`overview-info-item`}>
                    <span className={`overview-info-label`}>PO:</span>
                    <span style={purchaseOrder.length>30?{cursor:'pointer'}:{}}onClick={()=>{setShowFullPo(!showFullPo)}} title={purchaseOrder}>{(purchaseOrder.length>30 && !showFullPo)?purchaseOrder.toUpperCase().slice(0,28)+"...":purchaseOrder.toUpperCase()}</span>
                  </div>
                ) : null}
              </div>
              {isCA && (
                <div className={`overview-info-right`}>
                  {crState.state === 'STATE_CARGO_RELEASE_ACCEPTED' && (
                    <div
                      className={`overview-info-item`}
                      title='IID Filing Date'
                    >
                      <span className={`overview-info-label`}>
                      IID Acceptance Date:
                      </span>
                      <span>{dateOfFiling(crState)}</span>
                    </div>
                  )}
                  {(erState.state === 'STATE_ENTRY_ACCOUNTING_ACCEPTED' || erState.state === 'STATE_ENTRY_ACCOUNTING_AMEND_ACCEPTED') && (
                    <div
                      className={`overview-info-item`}
                      title='IID Filing Date'
                    >
                      <span className={`overview-info-label`}>
                        {canadaFormType[formType]} Acceptance Date:
                      </span>
                      <span> {formatDate(b3AcceptedDate)}</span>
                    </div>
                  )}
                  {k84Date && k84Date != '' && (
                    <div
                      className={`overview-info-item`}
                      title='IID Filing Date'
                    >
                      <span className={`overview-info-label`}>K84 Date:</span>
                      <span> {formatDate(k84Date)}</span>
                    </div>
                  )}
                  {paymentDueDate && paymentDueDate != '' && (
                    <div
                      className={`overview-info-item`}
                      title='IID Filing Date'
                    >
                      <span className={`overview-info-label`}>Payment Due Date:</span>
                      <span> {formatDate(paymentDueDate)}</span>
                    </div>
                  )}
                </div>
              )}
              <div
                className={`overview-info-right`}
                style={{ display: hideBol }}
              >
                {isGB && (
                  <div className={`overview-info-item`} title='MUCR/GMR'>
                    <span className={`overview-info-label`}>MUCR/GMR:</span>
                    <span>{mucr}</span>
                  </div>
                )}
                {isGB && (
                  <div className={`overview-info-item`} title='EPU'>
                    <span className={`overview-info-label`}>EPU:</span>
                    <span>{epu}</span>
                  </div>
                )}
                {isGB && (
                  <div className={`overview-info-item`} title='badge'>
                    <span className={`overview-info-label`}>BADGE:</span>
                    <span>{badge}</span>
                  </div>
                )}
                {isGB && mrn && (
                  <div className={`overview-info-item`} title='badge'>
                    <span className={`overview-info-label`}>MRN:</span>
                    <span>{mrn}</span>
                  </div>
                )}
                {shipmentCountry !== 'GB' &&
                  bolIdData &&
                  bolIdData.bol &&
                  bolIdData.bolType === '3' && (
                    <div
                      className={`overview-info-item`}
                      title='House Bill of Lading'
                    >
                      <span className={`overview-info-label`}>HBL:</span>
                      <span>{bolIdData.bol.toUpperCase()}</span>
                      <QryFuncModal
                        brokerId={window.brokerId}
                        launchFrom={'ISF_HEADER'}
                        hideLeftPanel={true}
                        dataType={'BOL'}
                        width={'75%'}
                        shipId={shipId}
                        value={bolIdData.bol ? bolIdData.bol.toUpperCase() : ''}
                        bolNum={
                          bolIdData.bol ? bolIdData.bol.toUpperCase() : ''
                        }
                        mBol={
                          bolIdData.masterBolNumber
                            ? bolIdData.masterBolNumber.toUpperCase()
                            : ''
                        }
                        recentQryCall={false}
                        baseUrl={window._env_.REACT_APP_BROKER_API_URL}
                        mot={bolIdData.modeOfTransport}
                        buttontext={
                          <Icon
                            name='info circle'
                            color='blue'
                            style={{ cursor: 'pointer' }}
                          />
                        }
                      />
                    </div>
                  )}
                {isUS && bolIdData && bolIdData.masterBolNumber && (
                  <div
                    className={`overview-info-item`}
                    title='Master Bill of Lading'
                    style={{ textTransform: 'uppercase', paddingRight: '5px' }}
                  >
                    <span className={`overview-info-label`}>
                      {bolIdData.modeOfTransport == 'TRUCK' ? 'PAPS' : 'MBL'}:
                    </span>{' '}
                    <span>
                      {bolIdData.masterBolNumber
                        ? bolIdData.masterBolNumber.toUpperCase()
                        : ''}
                    </span>
                    {canFileMBolQuery() === true ? (
                      <QryFuncModal
                        brokerId={window.brokerId}
                        launchFrom={'ISF_HEADER'}
                        hideLeftPanel={true}
                        dataType={'BOL'}
                        width={'75%'}
                        shipId={shipId}
                        isMBL={true}
                        queryRanFor={
                          bolIdData.modeOfTransport === 'AIR'
                            ? 'MAWB'
                            : bolIdData.modeOfTransport == 'TRUCK'
                            ? 'PAPS'
                            : 'MBL'
                        }
                        value={
                          bolIdData.modeOfTransport !== 'AIR' &&
                          bolIdData.masterBolNumber
                            ? bolIdData.masterBolNumber.toUpperCase()
                            : ''
                        }
                        bolNum={
                          bolIdData.modeOfTransport !== 'AIR' &&
                          bolIdData.masterBolNumber
                            ? bolIdData.masterBolNumber.toUpperCase()
                            : ''
                        }
                        mBol={
                          bolIdData.masterBolNumber
                            ? bolIdData.masterBolNumber.toUpperCase()
                            : ''
                        }
                        recentQryCall={false}
                        mot={bolIdData.modeOfTransport}
                        buttontext={
                          <Icon
                            name='info circle'
                            color='blue'
                            style={{ cursor: 'pointer' }}
                          />
                        }
                        adminAccountReadonly={
                          window.typeOfUser === 'BROKER_KN_ADMIN'
                        }
                        bolIdData={{ ...bolIdData, nonModalWindow: true }}
                        baseUrl={window._env_.REACT_APP_BROKER_API_URL}
                      />
                    ) : (
                      <Icon
                        name='info circle'
                        color='blue'
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          alert(
                            'MAWB queries are not allowed for FedEx, DHL, and UPS - i.e. carrier codes FX, 5X, and D0 or with MAWB’s beginning with 023, 406, and 936.  These MAWB queries will pull the entire manifest for the plane and slow down the system.  If you need more info please work with the Importer or Carrier. '
                          );
                        }}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        {warningMessage && (
          <div className={`warning-message`}>
            <Message warning icon key={warningMessage}>
              <Icon name='warning sign' className={'overview-warning-icon'} />
              <Message.Header className={'overview-warning-text'}>
                {warningMessage}
              </Message.Header>
            </Message>
          </div>
        )}
      </div>
      {!parentShipmentId &&
        entryState !== 'STATE_ASSIGNED_TO_BROKER' &&
        commentObjectForHeader !== 'Unknown Status' && (
          <HeaderAlert
            toggle={toggle}
            commentObjectForHeader={commentObjectForHeader}
            toggleState={toggleState}
            id={id}
            entryNumber={entryNumber}
            clicked={clicked}
            aceOpen={aceOpen}
            engineBolRecords={engineBolRecords}
            closseAce={closseAce}
            shipmentCountry={shipmentCountry}
            bolIdData={bolIdData}
            formType={formType}
            isParentShipment={isParentShipment}
          />
        )}
    </>
  );
}

export default ISFHeader
